import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import { ParagraphDocumentsFiltered as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphDocumentsFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphDocumentsFiltered: React.FC<ParagraphDocumentsFilteredProps> = ({ entity }) => {
  const paragraph = entity.toJS();

  const mediaCategoryId = paragraph.field_media_category[0].target_id;

  const urlParams = new URLSearchParams(window.location.search);
  const themeTargetId = urlParams.get('field_themes_target_id');

  const defaultFilters = {
    field_themes_target_id: themeTargetId,
  };

  return (
    <div className="ParagraphDocumentsFiltered">
      <View
        classes="row"
        id="documents_filtered"
        display="documents_filtered"
        withProvider
        defaultFilterValues={themeTargetId ? defaultFilters : null}
        args={[mediaCategoryId]}
        mediaCategoryId={mediaCategoryId}
      />
    </div>
  );
};

export default ParagraphDocumentsFiltered;
